import _ from 'lodash'
import axios from 'axios'

window._ = _

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

import axiosRetry from 'axios-retry'
axiosRetry(window.axios, { retries: 3 })

import { createApp } from 'vue'
import mitt from 'mitt'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { ResizeObserver as Polyfill } from '@juggle/resize-observer'

if (typeof window !== 'undefined') {
    window.ResizeObserver = window.ResizeObserver || Polyfill
}

/**
 * Vue Components
 */

// Universal
import DisclaimerButton from './components/DisclaimerButton.vue'
import NavBar from './components/NavBar.vue'

// Buying Guides
import RatingChart from './components/RatingChart.vue'
import ReadingProgressChart from './components/ReadingProgressChart.vue'

const app = createApp({
    components: {
        // Universal
        DisclaimerButton,
        NavBar,

        // Buying Guides
        RatingChart,
        ReadingProgressChart,
    },

    provide: {
        mitt: mitt(),
    },
})

Bugsnag.start({
    apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginVue()],
})

app.use(Bugsnag.getPlugin('vue'))
app.mount('#app')
